export default __webpack_public_path__ + "static/media/vale.8b6df7cd.JPG";